import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import fp from 'lodash/fp';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core';
import {Print} from '@material-ui/icons';
import {Formik, Form} from 'formik';

import {selectTicketFaxOptions} from 'ccm/lib/selectors-ccm';
import {FaxOptionsFormikField} from 'ccm/components/fields/FaxOptions';

export default function TicketFaxDialog({dialogRef}) {
    const [resolve, setResolve] = useState(null);
    const [ticket, setTicket] = useState(null);
    const faxOptions = useSelector(selectTicketFaxOptions(ticket));
    const [initialValues, setInitialValues] = useState({});

    const handleSubmit = values => {
        resolve(values.fax);
        setResolve(null);
    };
    const handleCancel = () => {
        resolve(null);
        setResolve(null);
    };

    dialogRef.current = ticketToFax =>
        new Promise((resolve, reject) => {
            setTicket(ticketToFax);
            setInitialValues({
                fax: fp.getOr([], 'attributes.data.fax_number', ticketToFax),
            });
            setResolve(() => resolve);
        });

    return (
        <Dialog open={!!resolve} onClose={handleCancel}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form>
                        <DialogTitle>Fax Ticket?</DialogTitle>
                        <DialogContent>
                            <FaxOptionsFormikField
                                name='fax'
                                options={faxOptions}
                                multiple
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCancel}>Cancel</Button>
                            <Button
                                type='submit'
                                variant='contained'
                                color='primary'
                                startIcon={<Print />}
                            >
                                Fax Ticket
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
